import { render, staticRenderFns } from "./FormsetHeader.vue?vue&type=template&id=3ea05a72&"
import script from "./FormsetHeader.vue?vue&type=script&lang=js&"
export * from "./FormsetHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports